import CustomButton from "./Button"
import { Image } from "antd"
import ArrowLeft from "../../assets/icons/arrow-left-black-icon.svg";
import { useNavigate } from "react-router-dom";
import { BTN_TXT } from "../../constants/constants";

const BackButton = ({ to }) => {
    const navigate = useNavigate();

    return (
        <CustomButton
            type="text"
            icon={<Image src={ArrowLeft} alt="Back" preview={false} width={8} />}
            onClick={() => to ? navigate(to) : navigate(-1)}
            style={{
                marginBottom: 10,
                fontWeight: 500,
                fontSize: 14,
                color: "#40566D",
                borderRadius: 5,
                padding:0,
            }}
        >
            &nbsp;{BTN_TXT.BACK}
        </CustomButton>
    )
}

export default BackButton